// src/components/ProgressBar.jsx
import React from 'react';

const ProgressBar = ({ answeredCount, total }) => {
  const progress = (answeredCount / total) * 100;

  return (
    <div className="w-full max-w-3xl mx-auto mt-4 sm:mt-6 mb-4 sm:mb-6 z-20 relative">
      <div className="h-4 w-full rounded-full bg-[#E5E7EB] shadow-[inset_0_2px_4px_rgba(0,0,0,0.06)]">
        <div
          className="h-full rounded-full bg-[#FFCE43] transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="mt-2 text-center text-[13px] sm:text-[14px] font-bold text-[#222D6A] tracking-wide font-poppins">
        {answeredCount} dari {total} soal terjawab
      </div>
    </div>
  );
};

export default ProgressBar;
